import { useQuery } from '@tanstack/react-query';

import { useTRPC } from '#src/trpc.js';

/**
 * Hook to get the latest revision ID for a given project.
 * Returns the revision ID if available, or null if there are no revisions.
 */
export function useLatestRevisionId(projectId: string | null | undefined): string | null {
	const trpc = useTRPC();

	const { data } = useQuery(
		trpc.revision.getLatest.queryOptions(
			{ projectId: projectId ?? '' },
			{
				enabled: !!projectId,
				staleTime: 30000, // Cache for 30 seconds
			},
		),
	);

	return data?.revision?.id ?? null;
}

